import script from "./TradingCompetitionBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradingCompetitionBanner.vue?vue&type=script&setup=true&lang=ts"

import "./TradingCompetitionBanner.vue?vue&type=style&index=0&id=9205cd5a&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9205cd5a"]])

export default __exports__